import { css } from 'aphrodite/no-important';
import React from 'react';

import styles from './styles';

interface Props {
  boundary: 'start' | 'end';
}

export const TrackingBoundaryIcon = ({ boundary }: Props) => {
  const isStart = boundary === 'start';

  return (
    <div className={css(styles.trackItemMarkerContainer)}>
      <span className={css(styles.trackItemMarker)}>
        <span
          className={css(styles.trackItemDot)}
          style={
            isStart
              ? { transform: `translateY(0.1875rem)` }
              : { transform: `translateY(0.5625rem)` }
          }
        />
        <span
          className={css(styles.trackItemPoint)}
          style={isStart ? { top: '1.1875rem' } : { bottom: '1.1875rem' }}
        />
        <span
          className={css(styles.trackItemPoint)}
          style={isStart ? { top: '1.5625rem' } : { bottom: '1.5625rem' }}
        />
        <span
          className={css(styles.trackItemPoint)}
          style={isStart ? { top: '1.9375rem' } : { bottom: '1.9375rem' }}
        />
      </span>
    </div>
  );
};
